define('modules/form_editor/views/editor_textarea',['require','exports','module','base/view','ldsh!../templates/editor_textarea'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_textarea"),
    events: {
      "change .js-rows": "updateModel"
    },
    updateModel: function(e){
      var rows = parseInt(this.$(".js-rows").val()) || 4;
      this.model.set("rows", rows);
      e.preventDefault();
    },
    onRender: function(){
      this.$el.i18n();
    }
  });
});

